module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/appuntamenti-specialistiche/appuntamenti-specialistiche.css
// module id = ./src/app/components/appuntamenti-specialistiche/appuntamenti-specialistiche.css
// module chunks = main